import { render, staticRenderFns } from "./create-abroadreturnorder.vue?vue&type=template&id=00b19df3&"
import script from "./create-abroadreturnorder.vue?vue&type=script&lang=ts&"
export * from "./create-abroadreturnorder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports